import { axios } from '@/utils/axios';

export enum DeleteResource {
  Collection = 'collections',
  COllectionItem = 'collection-items',
}

export const deleteResource = (
  id: string | number,
  resource: DeleteResource,
) => {
  return axios.delete(`/${resource}/${id}`);
};
